import React, { Fragment } from "react";
// @material-ui/core
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import { Toys } from "@material-ui/icons";
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import BarSustainableProject from "components/services/BarSustainableProject";

import styles from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

const useStyles = makeStyles(styles);

export default function SustainableProject() {
  const classes = useStyles();

  return (
    <Fragment>
          <Card>
            <CardBody>  
              <GridContainer>
               <GridItem xs={12} md={12}>
               <h4 className={classes.cardTitleGraphs}>
                <Toys className={classes.icontext} />
                Proyectos sostenibles
              </h4>
              <h6 className={classes.cardTitleGraphs}>
                Los tipos de solución sostenibles más demandantes por las
                empresas
              </h6>
              <BarSustainableProject />
              </GridItem>             
              </GridContainer>
            </CardBody>
          </Card>
    </Fragment>
  );
}
